import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class AppGenericResourceQueryCriteriClass extends BaseCriteriaModel {
  //hdr
  instance_guid?: Optional<string> = Optional.empty();
  instance_code?: Optional<string> = Optional.empty();
  instance_category?: Optional<string> = Optional.empty();
  resource_type?: Optional<string> = Optional.empty();
  tenant_hdr_guid?: Optional<string> = Optional.empty();
  subscription_hdr_guid?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();

  //exts
  ext_type?: Optional<string> = Optional.empty();
  ext_code?: Optional<string> = Optional.empty();
  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
  param_type?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
  value_numeric?: Optional<number> = Optional.empty();
  created_date?: Optional<string> = Optional.empty();
  resource_hdr_guid?: Optional<string> = Optional.empty();
}

export class AppGenericResourceCriteriaModelQuery {
  query = '';

  constructor(appGenericResourceCriteriaModel: AppGenericResourceQueryCriteriClass) {

    if (!appGenericResourceCriteriaModel) {
      return;
    }

    this.query += appGenericResourceCriteriaModel.instance_guid.filter(x => x !== '').map(x => '&instance_guid=' + x).orElse('');
    this.query += appGenericResourceCriteriaModel.instance_code.filter(x => x !== '').map(x => '&instance_code=' + x).orElse('');
    this.query += appGenericResourceCriteriaModel.instance_category.filter(x => x !== '').map(x => '&instance_category=' + x).orElse('');
    this.query += appGenericResourceCriteriaModel.resource_type.filter(x => x !== '').map(x => '&resource_type=' + x).orElse('');
    this.query += appGenericResourceCriteriaModel.tenant_hdr_guid.filter(x => x !== '').map(x => '&tenant_hdr_guid=' + x).orElse('');
    this.query += appGenericResourceCriteriaModel.subscription_hdr_guid.filter(x => x !== '').map(x => '&subscription_hdr_guid=' + x).orElse('');
    this.query += appGenericResourceCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');

    this.query += appGenericResourceCriteriaModel.ext_type.filter(x => x !== '').map(x => '&ext_type=' + x).orElse('');
    this.query += appGenericResourceCriteriaModel.ext_code.filter(x => x !== '').map(x => '&ext_code=' + x).orElse('');
    this.query += appGenericResourceCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += appGenericResourceCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += appGenericResourceCriteriaModel.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');
    this.query += appGenericResourceCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');
    this.query += appGenericResourceCriteriaModel.value_numeric.filter(x => x !== null).map(x => '&value_numeric=' + x).orElse('');
    this.query += appGenericResourceCriteriaModel.created_date.filter(x => x !== '').map(x => '&created_date=' + x).orElse('');
    this.query += appGenericResourceCriteriaModel.resource_hdr_guid.filter(x => x !== '').map(x => '&resource_hdr_guid=' + x).orElse('');

    this.query += '&status=' + appGenericResourceCriteriaModel.status;
    this.query += '&orderBy=' + appGenericResourceCriteriaModel.orderBy;
    this.query += '&order=' + appGenericResourceCriteriaModel.order;
    this.query += '&offset=' + appGenericResourceCriteriaModel.offset + '&limit=' + appGenericResourceCriteriaModel.limit;
  }
}
